import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { VehicleDetailView } from "@/views/vehicle-detail/vehicle-detail.view";
import { VehicleVinRedirectView } from "@/views/vehicle-detail/vehicle-vin-redirect.view";
import { Redirect, Route, Switch, useParams } from "wouter";
import { CreateView } from "./create/create.view";
import { UpdateView } from "./update/update.view";
import { VehicleView } from "./vehicle.view";

export function VehicleRoutes() {
  const ability = useAbility();
  const vehicleUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const vehicleDetailUuidRegex = generateUuidV4Regex({ paramName: "uuid" });
  const canManage = ability.can(Action.Manage, "Vehicle");

  return (
    <Switch>
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={vehicleUuidRegex} component={canManage ? UpdateView : ReadOnlyDetailRedirect} />
      <Route path={vehicleDetailUuidRegex} component={VehicleDetailView} />
      <Route path={"/:vin"} component={VehicleVinRedirectView} />
      <Route path={"/"} component={VehicleView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}

function ReadOnlyDetailRedirect() {
  const { uuid } = useParams<{ uuid: string }>();

  return <Redirect to={`/${uuid}`} replace />;
}
